import { useState } from "react";
import { CircleHelp, BookOpen, Mail, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FeedbackDialog } from "./FeedbackDialog";

const DOCS_URL = "https://notiflows.com/docs";
const SUPPORT_EMAIL = "support@notiflows.com";

export const HelpMenu = () => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8">
            <CircleHelp className="h-5 w-5" />
            <span className="sr-only">Help & Feedback</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56" align="end" forceMount>
          <DropdownMenuLabel>Help & Feedback</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <a href={DOCS_URL} target="_blank" rel="noopener noreferrer">
              <DropdownMenuItem className="cursor-pointer">
                <BookOpen className="mr-2 h-4 w-4" />
                View documentation
              </DropdownMenuItem>
            </a>
            <a href={`mailto:${SUPPORT_EMAIL}`}>
              <DropdownMenuItem className="cursor-pointer">
                <Mail className="mr-2 h-4 w-4" />
                Email support
              </DropdownMenuItem>
            </a>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => setFeedbackOpen(true)}
            >
              <MessageSquare className="mr-2 h-4 w-4" />
              Report feedback
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <FeedbackDialog open={feedbackOpen} onOpenChange={setFeedbackOpen} />
    </>
  );
};
